export enum IssueType {
  EPIC,
  USERSTORY,
  TASK,
  BUG,
  SUBTASK
}
